@if (isLoading) {
<div
    class="d-flex flex-column min-vw-100 justify-content-center align-items-center p-0 m-0 bg-body-secondary shadow py-2">
    <div class="text-center pt-3">
        <div class="spinner-border text-secondary" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</div>
} @else {
<nav class="navbar navbar-expand-lg sticky-top bg-body-secondary shadow">
    <div class="container-fluid">
        <a class="navbar-brand" href="#">
            <img [src]="profileLogo" [alt]="profileLogoAlt" height="48" class="d-inline-block align-text-center" />
            <span class="font-monospace m-0 p-0 d-none d-sm-inline-block">{{ configuration.appTitle }}</span>
        </a>
        <button class="navbar-toggler btn-sm border border-0" type="button" data-bs-toggle="collapse"
            data-bs-target="#navbarAppMenu" aria-controls="navbarAppMenu" aria-expanded="false"
            aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse font-monospace" id="navbarAppMenu">
            @if (errorText != '') {
            <ul class="navbar-nav me-auto mb-2 mb-lg-0" [innerHTML]="errorText"></ul>
            } @else {
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                @for (parent of roleMenus; track $index) {
                <li
                    class="nav-item
                    {{ parent.children.length === 0 ? '' : ' dropdown' }}
                    {{ parent.access_rights === 0 || parent.access_rights === null || parent.access_rights === undefined ? 'd-none' : '' }}">
                    <a data-bs-target=".navbar-collapse.show"
                        class="nav-link text-decoration-none {{ parent.children.length === 0 ? '' : ' dropdown-toggle' }}"
                        [routerLink]="parent.children.length === 0 ? parent.path_url : null"
                        [attr.aria-expanded]="parent.children.length === 0 ? null : 'false'"
                        [attr.role]="parent.children.length === 0 ? null : 'button'"
                        [attr.data-bs-toggle]="parent.children.length === 0 ? null : 'dropdown'"
                        [attr.aria-current]="parent.children.length === 0 ? 'page' : null"><i
                            class="px-1 pe-2 {{ (parent!.icon_class != '' || parent!.icon_class != null) ? parent!.icon_class : 'bi bi-three-dots' }}"></i>{{parent.title}}
                    </a>
                    @if (parent.children.length > 0) {
                    <ul class="dropdown-menu bg-body-secondary">
                        @for (child of parent.children; track $index) {
                        <li
                            class="{{ child.access_rights === 0 || child.access_rights === null || child.access_rights === undefined ? 'd-none' : '' }}">
                            @if (child.path_url === '###') {
                            <hr class="dropdown-divider" />
                            }@else {
                            <a class="dropdown-item" routerLink="{{ child.path_url }}" data-bs-toggle="collapse"
                                data-bs-target=".navbar-collapse.show"><i
                                    class="px-1 pe-2 {{ (child!.icon_class != '' || child!.icon_class != null) ? child!.icon_class : 'bi bi-three-dots' }}"></i>{{child.title
                                }}
                            </a>
                            }
                        </li>
                        }
                    </ul>
                    }
                </li>
                }
            </ul>
            }
            <div class="pe-2 font-monospace small">
                <p class="m-0 p-0">Hi {{ authUser!.user!.name }}</p>
                <a routerLink="/auth/profile" class="text-decoration-none" data-bs-toggle="collapse"
                    data-bs-target=".navbar-collapse.show">Profile</a>
                <span class="mx-1">|</span>
                <a routerLink="/auth/signout" class="text-decoration-none">Sign Out</a>
            </div>
        </div>
    </div>
</nav>
}